import { render, staticRenderFns } from "./JanusVideoroom.vue?vue&type=template&id=4337709d&lang=pug&"
import script from "./JanusVideoroom.vue?vue&type=script&lang=js&"
export * from "./JanusVideoroom.vue?vue&type=script&lang=js&"
import style0 from "./JanusVideoroom.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports